import React, { useContext, Fragment, useState } from 'react';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import Button from 'ls-common-client/dist/components/Button';
import useParagraphSplit from '../../hooks/useParagraphSplit';
import { Context } from '../../context/AppContext';
import ToggleSection from '../../components/ToggleSection';
import smoothScroll from '../../utils/smoothScroll';

const StyledRoot = styled(Container)`
  max-width: 1100px;
  margin: 0 auto 130px;
  padding: 0 20px;

  @media ${props => props.theme.mediaQueries.mobile} {
    margin: 16px;
  }
`;

const StyledBody = styled(Container)`
  display: flex;

  @media ${props => props.theme.mediaQueries.mobile} {
    display: block;
  }
`;

const StyledDescription = styled(Container)`
  font-size: 16px;
  p {
    margin: 0;
    display: inline;
    margin-right: 4px;
    font-size: 16px;
    min-width: 50%;
    flex: 1;
    &:first-child:not(:last-child) {
      padding-right: 30px;
    }
  }

  @media ${props => props.theme.mediaQueries.mobile} {
    p:first-child:not(:last-child) {
      padding-right: 0;
    }
  }
`;

const StyledTitle = styled.h2`
  font-size: 35px;
  font-family: 'Circular';
  font-weight: bold;
  line-height: 1.2em;
  color: #4a4a4a;
  text-align: center;
  margin-bottom: 60px;

  @media ${props => props.theme.mediaQueries.mobile} {
    font-size: 25px;
    margin-bottom: 30px;
    text-align: left;
  }
`;

const StyledDescriptionInner = styled(Container)`
  display: flex;
  margin-bottom: 20px;
  h2 {
    font-size: 18px;
  }
  h3 {
    font-size: 16px;
  }

  @media ${props => props.theme.mediaQueries.tablet} {
    flex-direction: column;
  }
  @media ${props => props.theme.mediaQueries.mobile} {
    flex-direction: column;
  }
`;

const StyledMore = styled(Button)`
  min-width: 220px;
  background: #ffffff;
  width: 220px;
  margin: 10px auto;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 22px;
  border: 1px solid ${props => props.theme.primary.normal};
  color: ${props => props.theme.primary.normal};
`;

const About = ({ description, title = `About` }) => {
  const {
    media: { desktop, tablet },
  } = useContext(Context);
  const [show, setShow] = useState();
  const paragraph = useParagraphSplit({
    data: description,
    splitParagraph: 1,
  });
  const mobileParagraph = useParagraphSplit({
    data: description,
    wordLimit: 50,
  });

  if (!description) return '';

  return (
    <StyledRoot className="Category__About__root">
      <StyledTitle className="Category__About__title">{title}</StyledTitle>

      <StyledBody className="Category__About__body">
        {description && (
          <StyledDescription className="Category__About__description">
            <StyledDescriptionInner className="Category__About__descriptionWrapper">
              {desktop || tablet ? (
                paragraph.map((text, key) => (
                  <p
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: text,
                    }}
                    key={key.toString()}
                  />
                ))
              ) : (
                <Fragment>
                  {!show && (
                    <p
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: mobileParagraph[0],
                      }}
                    />
                  )}
                  {mobileParagraph.length > 1 && (
                    <div className="Category__About__more">
                      <ToggleSection
                        moreText="Show More"
                        lessText="Show Less"
                        parentSelector=".Category__About__root"
                        onToggle={value => setShow(value)}
                      >
                        <p
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: description,
                          }}
                        />
                      </ToggleSection>
                    </div>
                  )}
                </Fragment>
              )}
            </StyledDescriptionInner>
          </StyledDescription>
        )}
      </StyledBody>

      <StyledMore
        className="Category__About__readMore"
        onClick={() =>
          smoothScroll(document.querySelector('.Category__ReadMore__root'), 66)
        }
      >
        Read More
      </StyledMore>
    </StyledRoot>
  );
};

export default About;
